// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1NZli","title":"FrontImage_title__PN_ci"};